import { render, staticRenderFns } from "./NotificationsList.html?vue&type=template&id=134e324a&external"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"
import style0 from "./NotificationsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports